import {getConfig} from '../helpers/config'

export class LoginService {

    login = async (code) => {
        const config = getConfig();
        const formData = new FormData();
        formData.append("code", code);
        formData.append("client_id", config?.arpa.client_id);
        formData.append("grant_type", "authorization_code");
        formData.append(
            "redirect_uri",
            config?.arpa.redirect_url
        );
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams(formData),
        };
        return await fetch(
            config?.arpa.login_url,
            options
        );
    }

    getUserInfo = async (token) => {
        const config = getConfig();
        const options = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };
        return await fetch(
            config?.arpa.user_info_url,
            options
        );
    }

    refresh = async () => {
        const config = getConfig();
        const formData = new FormData();
        formData.append('client_id', config?.arpa.client_id);
        formData.append('grant_type', 'refresh_token');
        formData.append('refresh_token', sessionStorage.getItem('refresh_token'));
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(formData)
        };
        return await fetch(
            config?.arpa.login_url,
            options
        );
    }

    logout = async (token, toNavigate) => {
        const config = getConfig();
        const formData = new FormData();
        formData.append("client_id", config?.arpa.client_id);
        //formData.append("id_token_hint", config?.arpa.client_id);
        formData.append("refresh_token", sessionStorage.getItem("refresh_token"));
        if (toNavigate) {
            formData.append("post_logout_redirect_uri", config?.arpa.redirect_url);
        }
        const options = {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(formData)
        };
        return await fetch(
            config?.arpa.logout_url,
            options
        );
    }

    getLoginUrl = async () => {
        const config = getConfig();
        const myState = this.generateState();
        sessionStorage.setItem('state', myState);
        const url = new URL(
            config?.arpa.auth_url
        );
        const params = {
            response_type: 'code',
            client_id: config?.arpa.client_id,
            redirect_uri: config?.arpa.redirect_url,
            scope: 'default',
            state: myState
        };
        url.search = new URLSearchParams(params).toString();

        return url;
    }

    generateState = () => {
        const len = this.getRandomInt(11, 21);
        return this.generateRandomString(len);
    }
    getRandomInt = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    }
    dec2hex = (dec) => {
        return dec.toString(16).padStart(2, '0');
    }

    generateRandomString = (len) => {
        const arr = new Uint8Array((len || 40) / 2);
        window.crypto.getRandomValues(arr);
        return Array.from(arr, this.dec2hex).join('');
    }
}
